<template>
  <div>
    <div id="dropdown" />
    <div class="md:flex md:flex-col">
      <div class="md:flex md:flex-col md:h-screen">
        <div class="md:flex md:flex-shrink-0">
          <div class="flex items-center justify-between px-6 py-4 bg-gray-100 border-b md:flex-shrink-0 md:justify-center md:w-56" style="background-color: #212529;">
            <Link class="mt-1" href="/">
              <img src="/images/White_logo_no_background.svg" width="120" />
            </Link>
            <dropdown class="md:hidden" placement="bottom-end">
              <template #default>
                <svg class="w-6 h-6 fill-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" /></svg>
              </template>
              <template #dropdown>
                <div class="mt-2 px-8 py-4 bg-gray-100 rounded shadow-lg" style="background-color: #e9ecef;">
                  <main-menu />
                </div>
              </template>
            </dropdown>
          </div>
          <div class="md:text-md flex items-center justify-between p-4 w-full text-sm bg-gray-100 border-b md:px-12 md:py-0" style="background-color: #212529;">
            <div class="mr-4 mt-1" />
            <dropdown class="mt-1" placement="bottom-end">
              <template #default>
                <div class="group flex items-center cursor-pointer select-none">
                  <div class="mr-1 text-gray-100 group-hover:text-orange-600 focus:text-indigo-600 whitespace-nowrap">
                    <span class="capitalize">{{ auth.user.first_name }}</span>
                    <span class="hidden md:inline capitalize">&nbsp;{{ auth.user.last_name }}</span>
                  </div>
                  <icon class="w-5 h-5 fill-gray-100 group-hover:fill-orange-700 focus:fill-indigo-600" name="cheveron-down" />
                </div>
              </template>
              <template #dropdown>
                <div class="mt-2 py-2 text-sm bg-white rounded shadow-xl">
                  <Link
                    v-if="auth.user.group_permissions.includes(rolePermissions.editUser, rolePermissions.deleteUser)
                      || auth.user.per_user_permissions.includes(rolePermissions.editUser, rolePermissions.deleteUser)"
                    class="block px-6 py-2 hover:text-white hover:bg-orange-500"
                    :href="`/users/${auth.user.id}/edit`"
                  >
                    My Profile
                  </Link>
                  <Link
                    v-if="auth.user.group_permissions.includes(rolePermissions.editUser, rolePermissions.deleteUser)
                      || auth.user.per_user_permissions.includes(rolePermissions.editUser, rolePermissions.deleteUser)"
                    class="block px-6 py-2 hover:text-white hover:bg-orange-500 hidden"
                    href="/users"
                  >
                    Manage Users
                  </Link>
                  <Link class="block px-6 py-2 w-full text-left hover:text-white hover:bg-orange-500" href="/logout" method="delete" as="button">Logout</Link>
                </div>
              </template>
            </dropdown>
          </div>
        </div>
        <div class="md:flex md:flex-grow md:overflow-hidden">
          <main-menu class="hidden flex-shrink-0 pl-2 pt-6 pr-5 bg-gray-50 overflow-y-auto md:block" style="background-color: #e9ecef;" />
          <div class="px-4 py-8 md:flex-1 md:p-12 md:overflow-y-auto bg-white" scroll-region>
            <flash-messages />
            <slot />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Dropdown from '@/Shared/Dropdown'
import MainMenu from '@/Shared/MainMenu'
import FlashMessages from '@/Shared/FlashMessages'

export default {
  components: {
    Dropdown,
    FlashMessages,
    Icon,
    Link,
    MainMenu,
  },
  props: {
    auth: Object,
  },
  data() {
    return {
      rolePermissions: {
        viewUsers: 'view_users',
        editUser: 'edit_user',
        addUser: 'add_user',
        deleteUser: 'delete_user',
      },
    }
  },
}
</script>
